"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Dropdown = _interopRequireDefault(require("../../../Dropdown"));
var _Input = _interopRequireDefault(require("../../../Input"));
var _OnClickOutside = _interopRequireDefault(require("../../../OnClickOutside"));
var _RoundButton = _interopRequireDefault(require("../RoundButton"));
var _RoundButton2 = require("../RoundButton/RoundButton");
var _Throbber = _interopRequireDefault(require("../../../Throbber"));
var _dialer = require("../../../../icons-react/dialer");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledButton = _Dropdown["default"].StyledButton,
  StyledContent = _Dropdown["default"].StyledContent,
  StyledDropdownIcon = _Dropdown["default"].StyledDropdownIcon;
var DEFAULT_PLACEHOLDER = 'Введите номер телефона';
var NOT_NUMBERIC_REGEX = /\D+/g;
var STARTS_WITH_8_REGEX = /^8/;
var RecentCalls = /*#__PURE__*/function (_React$PureComponent) {
  function RecentCalls(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, RecentCalls);
    _this = _callSuper(this, RecentCalls, [props]);
    _this.state = {
      value: props.value,
      isOpen: false
    };
    _this.el = /*#__PURE__*/_react["default"].createRef();
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleInput = _this.handleInput.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.inputRenderer = _this.inputRenderer.bind(_this);
    _this.listRenderer = _this.listRenderer.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(RecentCalls, _React$PureComponent);
  return (0, _createClass2["default"])(RecentCalls, [{
    key: "handleClick",
    value: function handleClick(value) {
      this.setState({
        value: value
      }, this.handleOutsideClick);
    }
  }, {
    key: "handleInput",
    value: function handleInput(_ref) {
      var currentTarget = _ref.currentTarget;
      var unformattedValue = currentTarget.value;
      var value = unformattedValue.replace(NOT_NUMBERIC_REGEX, '');
      var startsWith8 = STARTS_WITH_8_REGEX.test(value);
      if (value.length === 11 && startsWith8) {
        value = value.replace(/^8/, '7');
      }
      this.setState({
        value: value
      });
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(_ref2) {
      var key = _ref2.key;
      if (key === 'Escape') {
        this.setState({
          value: ''
        });
      }
      if (key === 'Enter') {
        this.handleSubmit();
      }
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick() {
      var isOpen = this.state.isOpen;
      if (isOpen) {
        this.handleToggle();
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      var _this2 = this;
      var onToggle = this.props.onToggle;
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      }, function () {
        var isOpen = _this2.state.isOpen;
        onToggle({
          isOpen: isOpen
        });
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var onCall = this.props.onCall;
      var value = this.state.value;
      onCall({
        value: value
      });
    }
  }, {
    key: "listRenderer",
    value: function listRenderer() {
      var _this3 = this;
      var calls = this.props.calls;
      if (!calls) {
        return /*#__PURE__*/_react["default"].createElement(StyledThrobber, {
          size: 16,
          color: "grey"
        });
      }
      if (calls.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(StyledEmpty, null, "\u041D\u0435\u0442 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0445 \u0432\u044B\u0437\u043E\u0432\u043E\u0432");
      }
      return /*#__PURE__*/_react["default"].createElement(StyledCallList, null, calls.map(function (_ref3) {
        var name = _ref3.name,
          number = _ref3.number;
        return /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(StyledCall, {
          functional: true,
          onClick: function onClick() {
            return _this3.handleClick(number);
          }
        }, /*#__PURE__*/_react["default"].createElement(StyledCallIcon, null), /*#__PURE__*/_react["default"].createElement(StyledCallInfo, null, /*#__PURE__*/_react["default"].createElement(StyledNumber, null, number), name && /*#__PURE__*/_react["default"].createElement(StyledName, null, name))));
      }));
    }
  }, {
    key: "inputRenderer",
    value: function inputRenderer() {
      var value = this.state.value;
      return /*#__PURE__*/_react["default"].createElement(StyledInput, {
        value: value,
        onChange: this.handleInput,
        onKeyDown: this.handleKeyPress,
        placeholder: DEFAULT_PLACEHOLDER
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        value = _this$state.value,
        isOpen = _this$state.isOpen;
      var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(this.props), this.props));
      delete props.onCall;
      delete props.onToggle;
      return /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], (0, _extends2["default"])({}, props, {
        onClickOutside: this.handleOutsideClick
      }), /*#__PURE__*/_react["default"].createElement(StyledContainer, null, /*#__PURE__*/_react["default"].createElement(StyledDropdown, {
        headRenderer: this.inputRenderer(),
        contentRenderer: this.listRenderer(),
        onToggle: this.handleToggle,
        open: isOpen
      }), /*#__PURE__*/_react["default"].createElement(StyledCallActionIcon, {
        disabled: value.length < 3,
        onClick: this.handleSubmit,
        actionType: _RoundButton2.Types.START_CALL
      })));
    }
  }]);
}(_react["default"].PureComponent);
RecentCalls.propTypes = {
  calls: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    number: _propTypes["default"].number.isRequire
  })),
  className: _propTypes["default"].string,
  onCall: _propTypes["default"].func,
  onToggle: _propTypes["default"].func,
  value: _propTypes["default"].string
};
RecentCalls.defaultProps = {
  calls: null,
  className: '',
  onCall: Function.prototype,
  onToggle: Function.prototype,
  value: ''
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "RecentCalls__StyledContainer",
  componentId: "sc-1gfysjp-0"
})(["display:flex;align-items:center;position:relative;"]);
var StyledDropdown = (0, _styledComponents["default"])(_Dropdown["default"]).withConfig({
  displayName: "RecentCalls__StyledDropdown",
  componentId: "sc-1gfysjp-1"
})(["width:100%;border:none;background:none;", "{border-radius:4px;border:1px solid #919499;width:200px;}", "{width:100%;padding:0;}", "{position:absolute;top:50%;margin-top:-2px;right:10px;}"], StyledButton, StyledContent, StyledDropdownIcon);
var StyledThrobber = (0, _styledComponents["default"])(_Throbber["default"]).withConfig({
  displayName: "RecentCalls__StyledThrobber",
  componentId: "sc-1gfysjp-2"
})(["padding:35px 0;position:relative;"]);
var StyledEmpty = _styledComponents["default"].div.withConfig({
  displayName: "RecentCalls__StyledEmpty",
  componentId: "sc-1gfysjp-3"
})(["width:100%;color:black;font-size:14px;line-height:70px;text-align:center;"]);
var StyledInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "RecentCalls__StyledInput",
  componentId: "sc-1gfysjp-4"
})(["width:100%;height:38px;border:none;color:white;font-size:13px;line-height:38px;border-radius:4px;font-weight:normal;padding:0 29px 0 11px;background-color:#16191b;"]);
var StyledCallList = _styledComponents["default"].ul.withConfig({
  displayName: "RecentCalls__StyledCallList",
  componentId: "sc-1gfysjp-5"
})(["border-radius:4px;width:100%;padding:0;li{border-top:2px solid #c2c5cc33;&:first-child{border-width:0;}}"]);
var StyledCall = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "RecentCalls__StyledCall",
  componentId: "sc-1gfysjp-6"
})(["display:flex;padding:0 10px;align-items:center;height:43px;text-align:left;width:100%;line-height:normal;"]);
var StyledCallIcon = (0, _styledComponents["default"])(_dialer.IncomingCall).withConfig({
  displayName: "RecentCalls__StyledCallIcon",
  componentId: "sc-1gfysjp-7"
})(["width:21px;margin-right:5px;"]);
var StyledCallInfo = _styledComponents["default"].div.withConfig({
  displayName: "RecentCalls__StyledCallInfo",
  componentId: "sc-1gfysjp-8"
})(["display:flex;flex-direction:column;justify-content:center;overflow:hidden;> span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}"]);
var StyledNumber = _styledComponents["default"].span.withConfig({
  displayName: "RecentCalls__StyledNumber",
  componentId: "sc-1gfysjp-9"
})(["color:#17181a;font-size:14px;"]);
var StyledName = _styledComponents["default"].span.withConfig({
  displayName: "RecentCalls__StyledName",
  componentId: "sc-1gfysjp-10"
})(["color:#919499;font-size:12px;"]);
var StyledCallActionIcon = (0, _styledComponents["default"])(_RoundButton["default"]).withConfig({
  displayName: "RecentCalls__StyledCallActionIcon",
  componentId: "sc-1gfysjp-11"
})(["border:none;margin-left:10px;"]);
var _default = exports["default"] = RecentCalls;